<div tabindex="-1"
     (mouseenter)="setShouldBlur(false)"
     (mouseleave)="setShouldBlur(true)"
>
    <ng-container *ngIf="showAutocompleterResults then autocompleterTargetUsers else initialTargetUsers"></ng-container>
</div>

<ng-template #autocompleterTargetUsers>
    @for (user of autocompleterTargetUserList || []; track $index) {
        <label class="custom-control custom-checkbox dropdown-item custom-checkbox-style1">
            <input class="custom-control-input"
                   type="checkbox"
                   [checked]="currentTargetUser?.email === user.target_user_email"
                   (change)="setCurrentTargetUserAutocomplete(user)"
            >
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description" style="text-overflow: '.'; white-space: nowrap;">
                {{ getUserDisplayName(user.target_user_first_name, user.target_user_last_name) }}
            </span>
        </label>
    }
</ng-template>

<ng-template #initialTargetUsers>
    @for (user of initialTargetUserList || []; track $index) {
        <label class="custom-control custom-checkbox dropdown-item custom-checkbox-style1">
            <input class="custom-control-input"
                   type="checkbox"
                   [checked]="currentTargetUser?.email === user.email"
                   (change)="setCurrentTargetUser(user)"
            >
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description" style="text-overflow: '.'; white-space: nowrap;">
                {{ getUserDisplayName(user.first_name, user.last_name) }}
            </span>
        </label>
    }
</ng-template>
